import { StatusVariant } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

export const STATUS = {
  Created: 'created',
  Acknowledged: 'acknowledged',
  Completed: 'completed',
  Discarded: 'discarded',
  Archived: 'archived',
} as const

export type ComplaintStatus = (typeof STATUS)[keyof typeof STATUS]

const VALID_STATUSES: readonly string[] = Object.values(STATUS)

export const isValidComplaintStatus = (status: string): status is ComplaintStatus => {
  return VALID_STATUSES.indexOf(status) !== -1
}

const STATUS_COLORS: Record<string, StatusVariant> = {
  [STATUS.Acknowledged]: 'info',
  [STATUS.Created]: 'warning',
  [STATUS.Completed]: 'positive',
  [STATUS.Discarded]: 'critical',
  [STATUS.Archived]: 'neutral',
} as const

export const statusLabel = (status: string): string => {
  switch (status) {
    case STATUS.Acknowledged:
      return i18n.t('complaints.status.in_progress')
    case STATUS.Created:
      return i18n.t('complaints.status.created')
    case STATUS.Completed:
      return i18n.t('complaints.status.processed')
    case STATUS.Discarded:
      return i18n.t('complaints.status.discarded')
    case STATUS.Archived:
      return i18n.t('complaints.status.archived')
    default:
      return status
  }
}

export const getStatusColor = (status: string): StatusVariant => {
  return STATUS_COLORS[status] || 'neutral'
}

const STATUS_TRANSITIONS: Record<string, string[]> = {
  [STATUS.Created]: [STATUS.Acknowledged],
  [STATUS.Acknowledged]: [STATUS.Completed, STATUS.Discarded, STATUS.Archived],
  [STATUS.Completed]: [STATUS.Archived],
  [STATUS.Discarded]: [STATUS.Archived],
  [STATUS.Archived]: [],
} as const

const getAvailableStatusTransitions = (currentStatus: string): string[] => {
  return STATUS_TRANSITIONS[currentStatus] || []
}

export const getStatusOptions = (currentStatus: string): Array<{ value: string; name: string }> => {
  return getAvailableStatusTransitions(currentStatus).map((status) => ({
    value: status,
    name: statusLabel(status),
  }))
}

export const getStatusOptionsForModal = (
  currentStatus: string
): Array<{ label: string; value: string }> => {
  return getAvailableStatusTransitions(currentStatus).map((status) => ({
    label: statusLabel(status),
    value: status,
  }))
}
